export enum AnalyticsEvent {
  SignInByEmail = "sign_in_by_email",
  SignInBySaml = "sign_in_by_saml",
  SignInByGoogle = "sign_in_by_google",
  SignUpByEmail = "sign_up_by_email",
  SignUpByGoogle = "sign_up_by_google",
}
